<template>
  <section class="pt-xs sm:p-sm lg:p-none lg:my-md">
    <Stack
      v-if="tiles?.length > 0"
      class="w-full lg:w-[calc(min(95.5vw,1542px))] md:aspect-[2.595] mx-auto"
      data-test-id="promotional-banners"
      direction="col"
      justify="center"
      gap="xs"
      :breakpoints="{
        direction: {
          md: 'row',
        },
        gap: {
          lg: 'sm',
        },
      }"
    >
      <Stack
        v-if="tiles[0]"
        class="w-full h-full md:w-auto md:aspect-[1.5] px-xs sm:px-none"
        data-test-id="first-promo-tile"
      >
        <NuxtLink v-if="tiles[0]?.link?.href" :to="tiles[0].link.href" class="w-full h-full">
          <NuxtPicture
            v-if="tiles[0]?.image"
            :src="tiles[0].image"
            fetchpriority="high"
            quality="65"
            preload
            width="1200"
            height="800"
            :img-attrs="{ class: 'w-full md:h-full', loading: 'eager' }"
          />
        </NuxtLink>
      </Stack>
      <Stack
        gap="xs"
        :breakpoints="{ direction: { md: 'col' }, gap: { lg: 'sm' } }"
        :class="[
          'w-full md:w-[37%] md:h-full',
          'whitespace-nowrap overflow-x-auto scroll-hidden scroll-smooth snap-x sm:snap-none snap-mandatory',
        ]"
      >
        <NuxtLink
          v-if="tiles[1]?.link?.href"
          :to="tiles[1].link.href"
          data-test-id="second-promo-tile"
          class="flex-shrink-0 sm:flex-1 snap-start w-[calc(max(317px,49vw))] md:w-full pl-xs sm:pl-none"
        >
          <NuxtPicture
            v-if="tiles[1]?.image"
            :src="tiles[1].image"
            quality="60"
            width="600"
            height="400"
            :img-attrs="{ class: 'w-full h-full' }"
          />
        </NuxtLink>
        <NuxtLink
          v-if="tiles[2]?.link?.href"
          :to="tiles[2].link.href"
          data-test-id="third-promo-tile"
          class="flex-shrink-0 sm:flex-1 snap-start w-[calc(max(317px,49vw))] md:w-full pr-xs sm:pr-none"
        >
          <NuxtPicture
            v-if="tiles[2]?.image"
            :src="tiles[2].image"
            quality="60"
            width="600"
            height="400"
            :img-attrs="{ class: 'w-full h-full' }"
          />
        </NuxtLink>
      </Stack>
    </Stack>
  </section>
</template>

<script lang="ts" setup>
import type { Component, Page } from "@bloomreach/spa-sdk";
import { usePromotionalTiles } from "../../composables/UseContent/usePromotionalTiles";

const props = defineProps<{ component: Component; page: Page }>();
const { component, page } = toRefs(props);

const tilesList = computed(() => usePromotionalTiles(page.value, component.value));

const tiles = computed(() => tilesList.value.promoTiles);
</script>
